import type { FinishBetaOnboardingInput } from "@crewledger/shared/workspace";
import type { WorkspaceSummary } from "@crewledger/shared/workspace";
import { apiFetch } from "@/lib/api";

export async function finishBetaOnboarding(
  input: FinishBetaOnboardingInput,
): Promise<WorkspaceSummary> {
  const response = await apiFetch<{
    data: { workspace: WorkspaceSummary | null };
  }>("/api/onboarding/beta", {
    method: "POST",
    body: JSON.stringify(input),
  });

  if (!response.data.workspace) {
    throw new Error("Workspace was not returned after onboarding");
  }

  return response.data.workspace;
}
